import { useDebouncedValue } from '@lumlab/platform-ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { apiRequest } from '@lumlab/platform-product/web';
import { access, defaultDirectoryPageSize, type DirectoryPage } from '../contract/index.ts';

export function useAccess(userId: string | undefined) {
    return useQuery({
        queryKey: ['access', userId],
        enabled: Boolean(userId),
        retry: false,
        queryFn: async ({ signal }) => access.parse(await apiRequest('/api/access', { signal })),
    });
}

export function useDirectory<T>(path: string, pageSize = defaultDirectoryPageSize) {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 250);
    const query = useQuery({
        queryKey: ['admin', path, debouncedSearch, page, pageSize],
        queryFn: ({ signal }) =>
            apiRequest<DirectoryPage<T>>(
                `${path}?${new URLSearchParams({ search: debouncedSearch, page: String(page), pageSize: String(pageSize) })}`,
                { signal },
            ),
    });
    return {
        ...query,
        search,
        page,
        pageSize,
        setPage,
        setSearch: (value: string) => {
            setSearch(value);
            setPage(1);
        },
    };
}
